import { createContext } from 'react';
import EditCashBoxContext from 'types/contexts/EditCashBoxContext';

export default createContext({} as EditCashBoxContext);
